export type PreviewGuideCoordinate = {
  x: number
  y: number
}

const GRID_STEPS = [5, 10, 20, 50, 100, 200]
const MIN_GRID_SCREEN_GAP = 12
export const PREVIEW_MOVE_SNAP_STEP = 5
export const PREVIEW_SIZE_SNAP_STEP = 5
export const PREVIEW_ROTATION_SNAP_STEP = 2

/**
 * 根据当前预览缩放选择网格步长，避免 Pad 小预览上网格过密。
 * @param stageScale 游戏设计坐标到屏幕显示坐标的缩放比例。
 * @returns 游戏设计坐标中的网格步长。
 */
export function resolvePreviewGuideGridStep(stageScale: number): number {
  const scale = Number.isFinite(stageScale) && stageScale > 0 ? stageScale : 1
  return GRID_STEPS.find((step) => step * scale >= MIN_GRID_SCREEN_GAP) ?? GRID_STEPS[GRID_STEPS.length - 1]!
}

/**
 * 格式化预览辅助层显示的左上角坐标。
 * @param coordinate 当前目标在游戏设计坐标中的左上角。
 * @returns 坐标展示文本。
 */
export function formatPreviewGuideCoordinate(coordinate: PreviewGuideCoordinate): string {
  return `X: ${Math.round(coordinate.x)}, Y: ${Math.round(coordinate.y)}`
}

/**
 * 按指定步长吸附数值。
 * @param value 原始数值。
 * @param step 吸附步长。
 * @returns 吸附后的数值。
 */
export function snapPreviewValue(value: number, step: number): number {
  const safeStep = Number.isFinite(step) && step > 0 ? step : 1
  const safeValue = Number.isFinite(value) ? value : 0
  return Math.round(safeValue / safeStep) * safeStep
}
